import React from 'react';

import { Box, Tooltip } from '@mui/material';
import { WarningIcon } from 'app/shared/componentsRestyled/coreDesignSystem/icons';
import PropTypes from 'prop-types';

import { IconSize } from 'constants/coreDesignSystem';

import { FORMAT_WARNING_TOOLTIP_POPPER_PROPS } from './FormatWarningTooltip.constants';
import { warningIconStyles } from './FormatWarningTooltip.styles';

const FormatWarningTooltip = ({ message }) => (
  <Tooltip arrow PopperProps={FORMAT_WARNING_TOOLTIP_POPPER_PROPS} placement="top" title={message}>
    <Box component="span" sx={warningIconStyles} tabIndex={0}>
      <WarningIcon size={IconSize[16]} />
    </Box>
  </Tooltip>
);

FormatWarningTooltip.propTypes = {
  message: PropTypes.string.isRequired,
};

export default FormatWarningTooltip;
